// extracted by mini-css-extract-plugin
export default {"toggle-button":"ToggleButton_toggle-button__U5F-9"};